export default __webpack_public_path__ + "static/media/ecosystem-terminal.a2b52d4d.png";